import feed from '../../components/feed';

import QuickView from '../product/quickView';

document.addEventListener('DOMContentLoaded', (e) => {
  new QuickView().init();
});

export default class HomeClass {
  constructor() {
    this.$instagramFeeds = $('.instagram-feed');
  }

  init() {
    if (this.$instagramFeeds.length > 0) {
      return feed.get(this.$instagramFeeds);
    }
  }
}
